import { render, staticRenderFns } from "./Tabla.vue?vue&type=template&id=0918dc8a&scoped=true&"
import script from "./Tabla.vue?vue&type=script&lang=js&"
export * from "./Tabla.vue?vue&type=script&lang=js&"
import style0 from "./Tabla.vue?vue&type=style&index=0&id=0918dc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0918dc8a",
  null
  
)

export default component.exports